function hasOwnProperty(obj, propName) {
    return Object.prototype.hasOwnProperty.call(obj, propName);
}
function debounce(fn, t, immediate) {
    var timer;
    return function () {
        var thisArg = this, args = arguments;
        var noTimer = !timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            timer = null;
            if (!immediate && typeof fn === "function")
                fn.apply(thisArg, args);
        }, t);
        if (immediate && noTimer && typeof fn === "function")
            fn.apply(thisArg, args);
    };
}
function throttle(fn, t, immediate) {
    var lastArgs, timer;
    return function () {
        var thisArg = this, args = Array.prototype.slice.call(arguments, 0), noTimer = !timer;
        function timeoutFn() {
            if (lastArgs) {
                if (typeof fn === "function")
                    fn.apply(thisArg, lastArgs);
                lastArgs = null;
                timer = setTimeout(timeoutFn, t);
            }
            else {
                timer = null;
            }
        }
        if (!noTimer || !immediate) {
            lastArgs = args;
        }
        if (!timer)
            timer = setTimeout(timeoutFn, t);
        if (immediate && noTimer && typeof fn === "function")
            fn.apply(thisArg, args);
    };
}
function _extend(deep, obj, obj2) {
    if (typeof obj !== "object" || typeof obj2 !== "object")
        return;
    for (var prop in obj2) {
        if (hasOwnProperty(obj2, prop)) {
            if (deep && typeof obj2[prop] === "object") {
                if (Array.isArray(obj2[prop]))
                    obj[prop] = [];
                else
                    obj[prop] = {};
                _extend(deep, obj[prop], obj2[prop]);
            }
            else {
                obj[prop] = obj2[prop];
            }
        }
    }
}
function extend(deep, obj) {
    var args = Array.prototype.slice.call(arguments, 0);
    if (typeof deep === "object") {
        obj = deep;
        deep = false;
        args.splice(0, 1);
    }
    else {
        deep = !!deep;
        args.splice(0, 2);
    }
    if (typeof obj !== "object")
        throw new Error("Object that you are extending, must be an object");
    for (var i = 0; i < args.length; i++) {
        _extend(deep, obj, args[i]);
    }
    return obj;
}
function formatStr(template, vars) {
    return template.replace(/\{(\w+)\}/gi, function (pattern, varName) {
        return (vars && vars[varName]) || "";
    });
}
function inherits(A, B) {
    var A_Proto = function () { };
    A_Proto.prototype = B.prototype;
    A.prototype = new A_Proto();
    A.prototype.constructor = A;
}
function cloneObj(obj) {
    var ret = {};
    for (var prop in obj) {
        if (hasOwnProperty(obj, prop))
            ret[prop] = obj[prop];
    }
    return ret;
}
function isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
}
function bind(fn, thisObj, args) {
    return function () {
        return fn.apply(thisObj, args || arguments);
    };
}
function objectCreate(p) {
    var A = function () { };
    A.prototype = p;
    var ret = new A();
    A.prototype = null;
    return ret;
}
module.exports = {
    debounce: debounce,
    extend: extend,
    formatStr: formatStr,
    inherits: inherits,
    clone: cloneObj,
    isArray: isArray,
    bind: bind,
    objectCreate: objectCreate,
    throttle: throttle
};
//# sourceMappingURL=module.js.map